import apiClient from "./ApiClient";

export async function fetchPrivacyPolicy(language = null) {
  const { data } = await apiClient.get("/legal/privacy-policy", {
    params: language ? { language } : undefined,
  });
  return data;
}

export async function fetchTermsOfService(language = null) {
  const { data } = await apiClient.get("/legal/terms-and-conditions", {
    params: language ? { language } : undefined,
  });
  return data;
}
